module.exports = __webpack_public_path__ + "img/BACK.7116de74.png";